document.addEventListener('DOMContentLoaded', function () {
  const productContainers = document.querySelectorAll('.product-container');
  const subtotalElement = document.querySelector('.checkout-total .total');

  function calculateSubtotal(cart) {
    let subtotal = 0;
    cart.items.forEach((item) => {
      subtotal += item.line_price;
    });
    subtotalElement.textContent = `${(subtotal / 100).toFixed(2)} zl`;
  }

  function updateCartItemQuantity(itemKey, newQuantity, totalPriceElement, selectElement) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: itemKey, quantity: newQuantity }),
    })
      .then((response) => response.json())
      .then((cart) => {
        const updatedItem = cart.items.find((item) => item.key === itemKey);

        if (updatedItem) {
          totalPriceElement.textContent = `${(updatedItem.line_price / 100).toFixed(2)} zl`;
          selectElement.value = updatedItem.quantity;
        } else {
          totalPriceElement.textContent = '0.00 zl';
          selectElement.value = 0;
        }
        calculateSubtotal(cart);
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
        alert('Failed to update the cart. Please try again.');
      });
  }

  function removeCartItem(itemKey, container) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: itemKey, quantity: 0 }),
    })
      .then((response) => response.json())
      .then((cart) => {
        container.remove();
        calculateSubtotal(cart);
      })
      .catch((error) => {
        console.error('Error removing item:', error);
        alert('Error while removing the item.');
      });
  }

  productContainers.forEach((container) => {
    const selectElement = container.querySelector('.count-products');
    const totalPriceElement = container.querySelector('.total-price');
    const itemKey = container.dataset.itemId;

    const currentQuantity = parseInt(totalPriceElement.getAttribute('quantity'), 10);

    if (!isNaN(currentQuantity) && currentQuantity > 0) {
      selectElement.value = currentQuantity;
    } else {
      selectElement.value = 1;
    }
    selectElement.addEventListener('change', () => {
      const newQuantity = parseInt(selectElement.value, 10);
      updateCartItemQuantity(itemKey, newQuantity, totalPriceElement, selectElement);
    });
  });

  document.querySelectorAll('a[data-item-id]').forEach((deleteButton) => {
    deleteButton.addEventListener('click', function (e) {
      e.preventDefault();
      const itemKey = deleteButton.getAttribute('data-item-id');
      const container = deleteButton.closest('.product-container');

      removeCartItem(itemKey, container);
    });
  });
});
